export default "__VITE_ASSET__D8ujjo3z__"